import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle} from 'reactstrap';
import {ButtonCancel} from "../../../components/buttons/buttonsActions";
import {GeoPickupForm} from "./_form";
import {GeoPickupList} from "./_list";


export default function GeoPickup(props){
    const [pickup] = useState(props?.item);
    const [editMode] = useState(false);
    const [item, setItem] = useState();

    const refForm = useRef(null);
    const refList = useRef(null);

    const setForm = () => {
        props.setForm();
    }

    const editItem = (itemP) => {
        setItem(itemP);
        refForm.current.setFormEdit(item);
    }

    const updateItem = (item) => {
        setItem(item)
    }

    const refreshList = () => {
        refList.current.refreshList();
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="fas fa-map-marked-alt mr-2"/>
                Registros para: { pickup.name }
            </CardTitle>

            <GeoPickupForm pickup={pickup} ref={refForm} refreshList={ refreshList } setForm={ setForm } item={item}/>

            <GeoPickupList pickup={pickup} ref={refList} editItem={ editItem }/>

            <CardBody className="border-top">
                <div className="float-right">
                    <ButtonCancel onClick={props.setForm}/>
                </div>
            </CardBody>
        </Card>
    );
}